import { MenuIdProjects } from '@jira/navigation-apps__constants/src/MenuIdProjects.tsx';
import { SidebarIdContent } from '@jira/navigation-apps__constants/src/SidebarIdContent.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { getNavigationResources } from '@jira/router-resources__navigation/src/getNavigationResources.tsx';
import { incidentExperimentTraitResource } from '@jira/router-resources__software-incidents/src/incidentExperimentTraitResource.tsx';
import { projectContextResource } from '@jira/router-resources__project-context/src/projectContextResource.tsx';
import { forgeProjectModuleResource } from '@jira/navigation-apps__resources/src/controllers/forge/index.tsx';
import { staticProjectSidebarNavigationResource } from '@jira/navigation-apps__resources/src/controllers/sidebar/static-project-sidebar/index.tsx';
import { staticProjectSidebarConnectAddonsNavigationResource } from '@jira/navigation-apps__resources/src/controllers/sidebar/static-project-sidebar-connect-addons/index.tsx';
import { AsyncHorizontalNavJira } from '@jira/navigation-apps__horizontal-nav-jira/src/async.tsx';
import { softwareGoalsClassicRoute } from '@jira/router-routes__classic-projects-routes/src/softwareGoalsClassicRoute.tsx';
import { fg } from '@atlassian/jira-feature-gating';
import {
	GSNSoftwareGoalsClassicPageEntrypoint,
	softwareGoalsClassicPageEntrypoint,
} from './ui/goals/index.tsx';
import type { Route } from '@atlassian/react-resource-router';

export const softwareGoalsClassicRouteEntry: Route = createEntry(softwareGoalsClassicRoute, () => ({
	group: 'classic-software',
	navigation: {
		menuId: MenuIdProjects,
		horizontal: AsyncHorizontalNavJira,
		sidebarId: SidebarIdContent,
	},
	resources: [
		...getNavigationResources({ isUsingSidebarEntrypoint: true }),
		// these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them if needed
		// A guide to check & cleanup: https://hello.atlassian.net/wiki/x/Q8XybwE
		incidentExperimentTraitResource,
		// eslint-disable-next-line jira/router/no-project-context-resource
		projectContextResource,
		forgeProjectModuleResource,
		staticProjectSidebarNavigationResource,
		staticProjectSidebarConnectAddonsNavigationResource,
		// end of resources expanded from getNavigationSidebarProjectResource
	],
	entryPoint: () =>
		fg('navx-global-side-nav')
			? GSNSoftwareGoalsClassicPageEntrypoint
			: softwareGoalsClassicPageEntrypoint,
	supportsPreviewPanel: true,
	bifrost: {
		bifrostGroup: 'shell-only',
	},
}));
